import { Model, NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import UpdateTransactionCommand from '../Models/Commands/UpdateTransactionCommand';
import RawGenericTransactionLookup from '../Models/Lookups/RawGenericTransactionLookup';
import CurrencyComponentVM from '../../../Common/Components/Currency/CurrencyComponentVM';
import StaticCurrencyLookup from '../../../Common/Models/StaticCurrencyLookup';
import StaticEventLookup from '../../EventMapping/Models/StaticEventSearchModal/StaticEventLookup';
import InstrumentSearchLookup from '../../InstrumentMapping/Models/InstrumentSearchLookup';

@NeoModel
export default class UpdateSecurityTransactionComponentVM extends Views.ViewModelBase {

    constructor(
        public authorisationService = AppService.get(Types.Neo.Security.AuthorisationService),
        public taskRunner = AppService.get(Types.Neo.TaskRunner)) {
        super(taskRunner);
    }

    public updateTransactionCommand = new UpdateTransactionCommand();
    public selectedSecurityTransactions: RawGenericTransactionLookup[] = [];
    public currencyComponentVM = new CurrencyComponentVM();
    public events: Model.PlainObject<StaticEventLookup>[] = [];
    public filteredEvents: Model.PlainObject<StaticEventLookup>[] = [];
    public instruments: Model.PlainObject<InstrumentSearchLookup>[] = [];
    public filteredInstruments: Model.PlainObject<InstrumentSearchLookup>[] = [];

    public clearInputs() {
        this.currencyComponentVM.selectedCurrency = new StaticCurrencyLookup();
        this.updateTransactionCommand.newStaticEventID = null;
        this.updateTransactionCommand.newStaticInstrumentID = null;
        this.updateTransactionCommand.newEventName = "";
        this.updateTransactionCommand.newStaticCurrencyId = null;
        this.updateTransactionCommand.newInstrumentDescription = "";
        this.updateTransactionCommand.priceOverride = null;
        this.updateTransactionCommand.newTime = null;
        this.updateTransactionCommand.newDateEvent = null;
        this.updateTransactionCommand.newTimeString = null;

    }
}